<template>
  <SidebarModal :modal="modal">
    <div
      class="flex h-full w-full items-center bg-gray-100 p-4 dark:bg-neutral-800"
    >
      <iframe
        class="aspect-video w-full rounded-lg"
        :src="modal?.payload?.src"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      ></iframe>
    </div>
  </SidebarModal>
</template>

<script>
import SidebarModal from '@/components/sidebar/SidebarModal.vue';

export default {
  name: 'VideoModal',
  components: {
    SidebarModal,
  },
  props: {
    modal: {
      type: Object,
      required: true,
    },
  },
};
</script>
